<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>
        <el-form :model="info" :rules="rules" ref="infoForm" label-width="100px">
            <el-form-item label="量表名称：" prop="name">
                <el-col :span="10">
                    {{ info.name }}
                </el-col>
            </el-form-item>
            <el-form-item label="类别：" prop="name">
                <el-col :span="10">
                    {{ info.name }}
                </el-col>
            </el-form-item>
            <el-form-item label="量表介绍：" prop="name">
                <el-col :span="10">
                    <el-input type="textarea" :rows="4" show-word-limit maxlength="500" placeholder="请输入内容" v-model="info.textarea">
                    </el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="量表介绍：" prop="name" class="is-required">
                <el-col :span="10">
                    <el-button type="primary" size="mini">添加建议</el-button>
                    <div>
                        <div style="display: flex; align-items: center;" class="jianyi">
                            <el-input type="text" placeholder="请输入分值" v-model="info.input1"></el-input>-
                            <el-input type="text" placeholder="请输入分值" v-model="info.input2"></el-input>
                        </div>
                        <el-input type="textarea" :rows="4" show-word-limit maxlength="500" placeholder="请输入内容" v-model="info.textarea">
                        </el-input>
                    </div>
                </el-col>
            </el-form-item>
        </el-form>
        <el-row>
            <el-col :span="12" style="margin-left: 100px; margin-top: 50px;">
                <el-button >返回上一页</el-button>
                <el-button type="primary">确认</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            info: {
                name: "11111",
                textarea: "",
                input2: "",
                input1: "",
            },
        };
    },
    components: {},
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style>
.jianyi .el-input {
    width: 150px;
}
</style>
